export default {
    responsible: 'Responsable',
    control: 'Control',
    controls: 'Controles',
    controlDomain: 'Dominio de control',
    controlAction: 'Acción de control',
    treatmentAction: 'Acción de tratamiento',
    controlsTitle: 'Controles del factor de impacto',
    forAsset: 'Para el activo',
    noControls: 'No hay controles asociados a este factor de impacto.',
    controlDescription: 'Descripción de la acción de tratamiento',
    minCharsHint: 'Mínimo {min} caracteres',
    followUpDate: 'Próximo seguimiento',
    creationDate: 'Fecha de creación',
    noControl: 'No existe el control',
    noControlsPage: 'No hay controles para mostrar, agrega controles a tus riesgos para hacerles seguimiento desde aquí.',
    noControlAction: 'No existe la acción de control',
    noControlActions: 'No hay acciones de control',
    noResponsible: 'No existe el responsable',
    noResponsibles: 'No hay responsables',
    selectTreatmentAction: 'Seleccione una acción de tratamiento',
    noTreatmentAction: 'No existe la acción de tratamiento',
    noTreatmentActions: 'No hay acciones de tratamiento',
    noControlDomain: 'No existe el dominio de control',
    noControlDomains: 'No hay dominios de control',
    controlMonitoring: 'Seguimiento de controles',
    associatingControl: 'Asociando control...',
    confirmControlAssociationLowRisk: 'Para este nivel de riesgo no es necesario implementar un control, ¿Estás seguro de asociar uno?',
    confirmDeleteControl: '¿Está seguro que desea eliminar el control? Esta acción no se puede deshacer.',
    deletingControl: 'Eliminando control...',
    deleteControlError: 'Ha ocurrido un error al eliminar el control:',
    controlDeleted: 'Control eliminado correctamente',
    controlStatus: 'Estado del control',
    controlFollowUpDate: 'Fecha de seguimiento',
    nextControlFollowUpDate: 'Fecha proximo seguimiento',
    followDescription: 'Descripción del seguimiento',
    followParticipants: 'Participantes del seguimiento',
    selectParticipant: 'Selecciona el participante',
    addEnterParticipant: 'Presiona Enter para agregar un nuevo participante',
    noParticipant: 'No existe el participante. Presiona Enter para agregarlo.',
    noParticipants: 'No hay participantes',
    addEvidences: 'Adjuntar evidencias',
    evidences: 'Evidencias',
    endFollows: 'Finalizar seguimientos a este control',
    controlGeneralDescription: 'Descripción del control',
    createNewFollowUp: 'Creación de nuevo seguimiento al control',
    noFollowUpsForControl: 'Parece que aún no hay seguimientos para este control.',
    confirmDeleteFollowUp: '¿Está seguro que desea eliminar este seguimiento? Se eliminará un registro de trazabilidad de forma irreversible.',
    deletingFollowUp: 'Eliminando seguimiento...',
    deleteFollowUpError: 'Error al eliminar el seguimiento',
    followUpDeleted: 'Seguimiento eliminado correctamente',
    loadingFollowUpInfo: 'Cargando información del seguimiento...',
    fetchFollowUpError: 'Ha ocurrido un error al consultar el seguimiento',
    explainAcceptanceOrTransfer: 'Explica brevemente la razón de aceptación o transferencia del riesgo.',
    controlSavedSuccess: 'Control guardado correctamente',
};
